export default "__VITE_ASSET__372afeb3__"